(function ($, SCS, debug) {
	'use strict';

	/**
	 * Create namespaces
	 */
	SCS.TV = SCS.TV || {};

	
	/**
	 * Channel Class
	 */
	function Channel(channelId, callback) {
		debug.log('SCS.TV > Channel > new', channelId, callback);
		this._init(channelId, callback);
	}

	// channel logos are not resized further as the quality would be too bad
	Channel.logoUrl = SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'content/images/tv/channel/{channelid}_image_{size}.png';

	// static functions
	Channel.getLogoUrlByChannelId = function (channelId, width) {
		var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
		return SCS.TV.Channel.logoUrl.replace('{channelid}', channelId).replace('{size}', 'W' + availableWidth);
	};

	// class functions
	Channel.prototype = {
		constructor: Channel,
		

		_init: function (channelId, callback) {
			this.channelId = channelId;
			this.logoUrl = SCS.TV.Channel.logoUrl.replace('{channelid}', channelId);
			this.name = '';

			if (channelId) {
				this._loadData(callback);
			}
		},

		_loadData: function (callback) {
			var channel = this;
			$.getJSON(SCS.Const.SNOOPY_SERVICE_PROXY_URL + 'catalog/tv/channels/list/(ids=' + this.channelId + ');', function (data) {
				debug.log('SCS.TV > Channel > loadData', data);
				if (data && data.Nodes && data.Nodes.Items && data.Nodes.Items.length > 0) {
					var channelInfo = SCS.TV.Helper.getFirstElementOfKindAndRoleAndShape(data.Nodes.Items, 'Channel');
					if (channelInfo) {
						channel._readData(channelInfo);
					}
				}
				if (typeof callback === 'function') {
					callback(channel);
				}
			});
		},

		_readData: function (channelInfo) {
			if (channelInfo.Content && channelInfo.Content.Description && channelInfo.Content.Description.Title) {
				this.name = channelInfo.Content.Description.Title;
				this.channelId = channelInfo.Identifier;
				this.logoUrl = SCS.TV.Channel.logoUrl.replace('{channelid}', this.channelId);
			}
		},

		/**
		 * Public API
		 */
		getLogoUrl: function (width) {
			var availableWidth = SCS.TV.Helper.getBestImageWidth(width);
			return this.logoUrl.replace('{size}', 'W' + availableWidth);
		}
	};

	
	SCS.TV.Channel = Channel;

}(window.jQuery, window.SCS = window.SCS || {}, window.debug));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/tv/SCS.TV.Channel.js
// module id = 89
// module chunks = 0